// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

import type { MapStateToProps } from 'react-redux';
import type Messages from '../../ui/ui.types.js';

import Select, { Options } from '../../form/select.js';

import { selectAssignToOptions } from '../calendar.selectors.js';

import { priorityOptions, DISCREPANCY_ADD } from '../calendar.consts.js';

import { addDiscrepancy } from '../calendar-day.actions.js';

type OwnProps = {|
  addDiscrepancy: Function
|};

type MappedState = {|
  UI: $ElementType<ReduxState, 'UIState'>,
  discrepancyForm: $ElementType<ReduxState, 'discrepancyForm'>,
  accessgroups: $ElementType<ReduxState, 'accessgroups'>,
  UI: state.UI,
  discrepancyForm: state.discrepancyForm,
  accessgroups: state.accessgroups,
  assignToOptions: Options
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

class DiscrepancyAdd extends React.Component<Props> {
  static footer = true;

  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit: Function;
  handleSubmit(e) {
    e.preventDefault();
    return this.props.addDiscrepancy();
  }

  handleChange: Function;
  handleChange(name, val) {
    return this.props.fieldAttrs.onChange(name, val);
  }

  render() {
    const { UI, accessgroups, discrepancyForm, fieldAttrs } = this.props;

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label className="input-sm discrepancy-field required-label" htmlFor="discrepancy-name">
              Name
            </label>
            <input
              type="text"
              id="discrepancy-name"
              className="form-control discrepancy-field"
              name="discrepancyForm.name"
              value={discrepancyForm.name}
              disabled={UI.progress}
              required
              {...fieldAttrs}
            />
          </div>

          {accessgroups.discrepanciesManage ? (
            <Select
              pretty
              searchable={false}
              clearable={false}
              removeSelected={false}
              simpleValue
              label="Assigned To"
              placeholder="Select Mechanic"
              disabled={UI.progress}
              className="discrepancy-field"
              options={this.props.assignToOptions}
              value={discrepancyForm.assignTo}
              onChange={this.handleChange.bind(this, 'discrepancyForm.assignTo')}
            />
          ) : null}

          <Select
            pretty
            searchable={false}
            clearable={false}
            removeSelected={false}
            simpleValue
            label="Priority"
            disabled={UI.progress}
            className="discrepancy-field"
            options={priorityOptions}
            onChange={this.handleChange.bind(this, 'discrepancyForm.priority')}
            value={discrepancyForm.priority}
            required
            {...fieldAttrs}
          />

          <div className="form-group">
            <label
              className="input-sm discrepancy-field required-label"
              htmlFor="discrepancy-description"
            >
              Description
            </label>
            <textarea
              id="discrepancy-description"
              className="form-control discrepancy-field"
              name="discrepancyForm.description"
              value={discrepancyForm.description}
              disabled={UI.progress}
              rows="4"
              required
              {...fieldAttrs}
            />
          </div>

          <input id={DISCREPANCY_ADD} type="submit" style={{ display: 'none' }} />
        </form>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  UI: state.UI,
  discrepancyForm: state.discrepancyForm,
  accessgroups: state.accessgroups,
  assignToOptions: selectAssignToOptions(state)
});

export default connect(
  mapStateToProps,
  {
    addDiscrepancy,
    ...formActions
  },
  mergeActionsToProps
)(DiscrepancyAdd);
